import { connect } from 'react-redux';
import {PurchaseData, datosCompra, eventoSeleccionado} from '../../../types/types';
import {
    buildEventAnalyticsConfig,
    matchesEventHash,
    trackEventAnalytics,
} from '../../../utilities/eventAnalytics';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {Col,Button, Row} from 'reactstrap';
import CompraEventoSingular from '../compra/CompraEventoSingular';
import CompraEventoPlural from '../compra/CompraEventoPlural';
import CompraEventoSeat from '../compra/CompraEventoSeat';
import '../../sass/evento_seleccionado/paso_dos.scss';
import DetalleCompra from '../compra/DetalleCompra';
import TituloEvento from './TituloEvento';
import Timer from './Timer';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

type configObjectDatosComprados = {
    eventsReducer: {
        datosCompraPasoDos: PurchaseData;
        detalleCompra:datosCompra;
        eventoSeleccionado: eventoSeleccionado;
    }
  }

const PasoDosEvento = ({datosCompraPasoDos, detalleCompra, eventoSeleccionado, setTimeOut}:{datosCompraPasoDos:PurchaseData, detalleCompra:datosCompra, eventoSeleccionado: eventoSeleccionado, setTimeOut: React.Dispatch<React.SetStateAction<boolean>>}) => {
    const navigate = useNavigate();
    const { hashEvent } = useParams();
    const [compraSingularEnProceso, setCompraSingularEnProceso] = useState(false);
    useEffect(() => {
        window.onpageshow = (event) => {
            if (event.persisted) {
                console.log('Página restaurada desde el caché, recargando...');
                window.location.reload();
            }
          };
      }, []);

    useEffect(() => {
        if (!matchesEventHash(eventoSeleccionado, hashEvent)) {
            return;
        }
        trackEventAnalytics(buildEventAnalyticsConfig(eventoSeleccionado), 'AddToCart');
    }, [eventoSeleccionado, hashEvent]);
    
    return (
        <div className='compra-paso-dos mb-4'>
          {datosCompraPasoDos && <>
            {detalleCompra && <TituloEvento />}
            <Row>
                {datosCompraPasoDos.purchaseType === 'SINGULAR' && (
                    <CompraEventoSingular onPurchaseBusy={setCompraSingularEnProceso} />
                )}
                {datosCompraPasoDos.purchaseType === 'PLURAL' && <CompraEventoPlural />}
                {datosCompraPasoDos.purchaseType === 'SEAT' && <CompraEventoSeat />}
                <Col md={5} className='d-flex justify-content-start flex-column'>
                    {detalleCompra && <DetalleCompra />}

                    {detalleCompra &&
                        <Button
                        className=' p-3 ps-4 pe-4 mt-3'
                        onClick={()=>{
                            const hash = window.location.pathname.split("/")[2];
                            navigate(`/evento/${hash}/step/3`)
                        }}
                        disabled={detalleCompra.ticketsQuantity === 0 || compraSingularEnProceso}> SIGUIENTE PASO <ArrowForwardIosIcon style={{"fontSize":"0.9rem"}}/></Button>}
                    <Button className='back_2 p-3 ps-4 pe-4 mt-4' onClick={()=>{window.history.go(-1)}}><ArrowBackIosIcon style={{"fontSize":"0.9rem"}} /> PASO ANTERIOR</Button>
                    <Timer setTimeOut={setTimeOut} />
                </Col>
            </Row>
          </>}
        </div>
    );
};

const mapStateToProps = (state: configObjectDatosComprados) => {
    return {
        datosCompraPasoDos: state.eventsReducer.datosCompraPasoDos,
        detalleCompra: state.eventsReducer.detalleCompra,
        eventoSeleccionado: state.eventsReducer.eventoSeleccionado
    }
}
export default connect(
    mapStateToProps,
    null
)(PasoDosEvento);

